import React, { Fragment } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
// TAD-5644 — `react-moment` removed (CJS interop incompatible with Vite,
// and the only previous usage in this file was already commented out).
import ReassignMemberIcon from "../../../../../assets/icons/Icon-Reassign-Members-Green-36px.svg";
import Arrow from "../../../../../assets/icons/Icon-Right-Arrow-Black-32px.svg";
// import "./TaskAuditSingleComment.scss";
import "./TaskAuditReassignMembers.scss";
import TaskReassignMemberPopover from "./TaskReassignMemberPopover";
import PropTypes from 'prop-types';

const TaskAuditReassignMembers = ({
  comment,
  projectMembers,
  userName,
  userEmail,
  actionType,
}) => {

  const reassignedMembers = (m) => {
    if (m == "") {
      return [];
    }
    else {
      let members = m.split(",");
      return projectMembers.filter((member) => members.includes(member.Id.toString()));
    }
  }

  return (
    <div className="TaskAuditReassignSection flex-grow-1 assignMemberContainer">
      {/* <div className="taskAuditDateTimeText align-items-start">
        <Moment format="MM/DD/YYYY">{comment?.Created}</Moment> <Moment format="h:mm a">{comment?.Created}</Moment>
      </div> */}
      <div className="user">
        <div>
          <img src={ReassignMemberIcon}></img>
        </div>
        <div className="userDetails">
          <div className="reassign-heading">
            Member Permission(s) Re-assigned
          </div>
          <OverlayTrigger
            placement="top"
            overlay={<Tooltip>{userEmail}</Tooltip>}
          >{
              <span className="reassign-by">by <b>{userName?.length > 30 ? `${userName?.slice(0, 30)}...` : userName} </b></span>
            }
          </OverlayTrigger>
        </div>
      </div>

      <div>
      {
          comment.ReassignTaskMembers?.OwnerChanged &&
            <div>
              <div className="memberRole">
                Owner
              </div>
              <div className="memberChange">
                <div className="oldPermission">
                  {comment.ReassignTaskMembers.OwnerOld == "" ? <span><b>Unassigned</b></span>
                    : <TaskReassignMemberPopover
                      reassignMembers={reassignedMembers(comment.ReassignTaskMembers.OwnerOld)}
                    ></TaskReassignMemberPopover>}
                </div>
                <img src={Arrow} alt="Transfer Arrow"></img>
                <div className="newPermission">
                  {comment.ReassignTaskMembers.OwnerNew == "" ? <span><b>Unassigned</b></span>
                    : <TaskReassignMemberPopover
                      reassignMembers={reassignedMembers(comment.ReassignTaskMembers.OwnerNew)}
                    ></TaskReassignMemberPopover>}
                </div>
              </div>
            </div>           
        }
        {
          comment.ReassignTaskMembers?.ApproverChanged &&
            <div>
              <div className="memberRole">
                Approver
              </div>
              <div className="memberChange">
                <div className="oldPermission">
                  {comment.ReassignTaskMembers.ApproverOld == "" ? <span><b>Unassigned</b></span>
                    : <TaskReassignMemberPopover
                      reassignMembers={reassignedMembers(comment.ReassignTaskMembers.ApproverOld)}
                    ></TaskReassignMemberPopover>}
                </div>
                <img src={Arrow} alt="Transfer Arrow"></img>
                <div className="newPermission">
                  {comment.ReassignTaskMembers.ApproverNew == "" ? <span><b>Unassigned</b></span>
                    : <TaskReassignMemberPopover
                      reassignMembers={reassignedMembers(comment.ReassignTaskMembers.ApproverNew)}
                    ></TaskReassignMemberPopover>}
                </div>
              </div>
            </div>
        }
        {
          comment.ReassignTaskMembers?.EditorChanged &&
            <div>
              <div className="memberRole">
                Editor
              </div>
              <div className="memberChange">
                <div className="oldPermission">
                      {comment.ReassignTaskMembers.EditorOld == "" ? <span><b>Unassigned</b></span>
                        : <TaskReassignMemberPopover
                          reassignMembers={reassignedMembers(comment.ReassignTaskMembers.EditorOld)}
                        ></TaskReassignMemberPopover>}
                </div>
                <img src={Arrow} alt="Transfer Arrow"></img>
                <div className="newPermission">
                  {comment.ReassignTaskMembers.EditorNew == "" ? <span><b>Unassigned</b></span>
                    : <TaskReassignMemberPopover
                      reassignMembers={reassignedMembers(comment.ReassignTaskMembers.EditorNew)}
                    ></TaskReassignMemberPopover>}
                </div>
              </div>
            </div>
        }
        {
          comment.ReassignTaskMembers?.ViewerChanged &&
            <div>
              <div className="memberRole">
                Viewer
              </div>
              <div className="memberChange">
                <div className="oldPermission">
                  {comment.ReassignTaskMembers.ViewerOld == "" ? <span><b>Unassigned</b></span>
                    : <TaskReassignMemberPopover
                      reassignMembers={reassignedMembers(comment.ReassignTaskMembers.ViewerOld)}
                    ></TaskReassignMemberPopover>}
                </div>
                <img src={Arrow} alt="Transfer Arrow"></img>
                <div className="newPermission">
                  {comment.ReassignTaskMembers.ViewerNew == "" ? <span><b>Unassigned</b></span>
                    : <TaskReassignMemberPopover
                      reassignMembers={reassignedMembers(comment.ReassignTaskMembers.ViewerNew)}
                    ></TaskReassignMemberPopover>}
                </div>
              </div>
            </div>          
        }
      </div>      
    </div>
  )

};

TaskAuditReassignMembers.propTypes = {
  comment: PropTypes.shape({
      ReassignTaskMembers: PropTypes.shape({
      OwnerChanged: PropTypes.bool,
      OwnerOld: PropTypes.string,
      OwnerNew: PropTypes.string,
      ApproverChanged: PropTypes.bool,
      ApproverOld: PropTypes.string,
      ApproverNew: PropTypes.string,
      EditorChanged: PropTypes.bool,
      EditorOld: PropTypes.string,
      EditorNew: PropTypes.string,
      ViewerChanged: PropTypes.bool,
      ViewerOld: PropTypes.string,
      ViewerNew: PropTypes.string,
    }),
  }),  
};

export default TaskAuditReassignMembers;